// extracted by mini-css-extract-plugin
module.exports = {"default":"_2GRYJ3Ub2SuuvwLp88X75i"};